import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useStyles from './CheckboxBlock.styles';
import ImportTypeCheckbox from './ImportTypeCheckbox';
import { PAYMENT_TYPE_NAMES } from '../utils';

const CheckboxBlockComponent = ({
  checkboxDataStructure: data,
  header,
  onChange,
  permissions,
  selectedData,
  subHeader,
  ...rest
}) => {
  const classes = useStyles();
  const dataHasToBeCheckedByPermissions = useMemo(
    () => data.find((item) => item.label === PAYMENT_TYPE_NAMES.DOMESTIC_WIRE),
    [data]
  );
  const allowedCheckboxes = useMemo(
    () =>
      dataHasToBeCheckedByPermissions
        ? data.filter((item) => permissions.includes(item.label))
        : data,
    [data, dataHasToBeCheckedByPermissions, permissions]
  );

  return (
    <div className={classnames(classes.wrapper)}>
      <div className={classes.headerWrapper}>
        <h4 className={classes.header}>{header}</h4>
        {subHeader && <span className={classes.subHeader}>{subHeader}</span>}
      </div>
      <div className={classnames('col-12 no-gutters', classes.singleCheckboxWrapper)}>
        {allowedCheckboxes.map((item) => (
          <ImportTypeCheckbox
            key={item.label}
            selectedCheckboxes={selectedData}
            onSelect={onChange}
            data={item}
            {...rest}
          />
        ))}
      </div>
    </div>
  );
};

CheckboxBlockComponent.propTypes = {
  selectedData: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkboxDataStructure: PropTypes.arrayOf(PropTypes.shape({})),
  header: PropTypes.string,
  subHeader: PropTypes.string,
  onChange: PropTypes.func,
  permissions: PropTypes.arrayOf(PropTypes.shape({}))
};

CheckboxBlockComponent.defaultProps = {
  checkboxDataStructure: [{}],
  header: '',
  subHeader: '',
  onChange() {},
  permissions: []
};

export default CheckboxBlockComponent;
